import {SignupQuote} from "../../../Api/SignupQuote";
import {formatMoney} from "../../../Helpers/Currency/Currency";
import "./SignupQuoteSummary.scss";

interface Props {
    quote: SignupQuote | null;
    loading: boolean;
    error: string;
    retry: () => void;
    continueWithoutAffiliate?: () => void;
}

export default function SignupQuoteSummary({quote, loading, error, retry, continueWithoutAffiliate}: Props) {
    return (
        <section className="signup-quote" aria-label="First payment summary" aria-live="polite">
            {loading && <p>Confirming your first payment...</p>}
            {error && <>
                <p role="alert">{error}</p>
                <button type="button" onClick={retry}>Retry price check</button>
                {continueWithoutAffiliate && <button type="button" onClick={continueWithoutAffiliate}>Continue without affiliate discount</button>}
            </>}
            {quote && <>
                {quote.affiliate_eligible && <>
                    <p><span>Price after current offer</span><span>{formatMoney(quote.amount_before_affiliate_minor, quote.currency)}</span></p>
                    <p><span>Affiliate discount (10%)</span><span>-{formatMoney(quote.affiliate_amount_off_minor, quote.currency)}</span></p>
                </>}
                <p className="signup-quote__total"><strong>First payment</strong><strong>{formatMoney(quote.amount_due_minor, quote.currency)}</strong></p>
                {quote.affiliate_eligible && (
                    <p className="signup-quote__terms">Your affiliate discount applies to the first invoice only. Renewal pricing and existing offer terms are shown with your plan.</p>
                )}
            </>}
        </section>
    );
}
